var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.5,
    height: 13.391,
    viewBox: "0 0 61.5 13.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MyMusic",
    transform: "translate(-656.155 -443.84)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(656.155 444.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(0 2.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M664.474,480.147V475.39a.914.914,0,0,0-1.015-.924,1.23,1.23,0,0,0-1.285,1.4v4.283H660.3V475.39a.914.914,0,0,0-1.014-.924,1.23,1.23,0,0,0-1.285,1.4v4.283h-1.849v-7.124h1.916v.9a2.319,2.319,0,0,1,1.961-1.015,2.076,2.076,0,0,1,1.961,1.06,2.42,2.42,0,0,1,2.074-1.06,2.065,2.065,0,0,1,2.3,2.209v5.05h-1.894Z",
    transform: "translate(-656.155 -472.91)",
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(10.483 2.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M763.8,481.833c-.293.857-.519,1.15-1.06,1.353a4.55,4.55,0,0,1-1.984.158v-1.4a1.194,1.194,0,0,0,.518.09,1.165,1.165,0,0,0,1.15-1.195V480.8h0l-2.683-7.44h2.074l1.578,5.185,1.488-5.185H766.8Z",
    transform: "translate(-759.739 -473.356)",
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(17.742 2.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M839.808,480.147V475.39a.914.914,0,0,0-1.015-.924,1.23,1.23,0,0,0-1.285,1.4v4.283h-1.871V475.39a.914.914,0,0,0-1.014-.924,1.23,1.23,0,0,0-1.285,1.4v4.283h-1.871v-7.124h1.826v.9a2.32,2.32,0,0,1,1.961-1.015,2.076,2.076,0,0,1,1.961,1.06,2.42,2.42,0,0,1,2.074-1.06,2.065,2.065,0,0,1,2.3,2.209v5.05h-1.781Z",
    transform: "translate(-831.467 -472.91)",
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(28.947 2.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M946.665,481.148v-.857a2.306,2.306,0,0,1-2.119,1.15,2.187,2.187,0,0,1-2.367-2.457v-4.96h1.871v4.531c0,.857.383,1.285,1.195,1.285a1.351,1.351,0,0,0,1.488-1.4v-4.419H948.6v7.124Z",
    transform: "translate(-942.179 -474.024)",
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(35.935 2.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1016.894,479.809a3.541,3.541,0,0,1-2.3.631c-2.164,0-3.314-.812-3.359-2.367h1.826a1.179,1.179,0,0,0,.338.676,1.912,1.912,0,0,0,1.1.248c.857,0,1.353-.248,1.353-.721,0-.293-.18-.428-.631-.586l-2.209-.676a2.309,2.309,0,0,1-1.15-.586,1.725,1.725,0,0,1-.383-1.15c0-1.488,1.1-2.367,2.931-2.367,1.916,0,3.066.9,3.111,2.412h-1.781c0-.631-.473-.969-1.308-.969-.631,0-1.06.248-1.06.676,0,.293.135.383.631.541l2.345.676a1.771,1.771,0,0,1,1.4,1.781A2.538,2.538,0,0,1,1016.894,479.809Z",
    transform: "translate(-1011.235 -472.91)",
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(43.104 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 1.871,
    height: 1.871,
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(43.104 2.683)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 1.871,
    height: 7.124,
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(45.697 2.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1111.049,480.04c-2.119,0-3.359-1.353-3.359-3.742,0-2.412,1.24-3.832,3.359-3.832a2.912,2.912,0,0,1,3.111,2.8h-1.781c-.2-.924-.541-1.285-1.308-1.285a1.256,1.256,0,0,0-1.15.586,4.241,4.241,0,0,0-.338,1.736c0,1.4.541,2.254,1.488,2.254.721,0,1.1-.338,1.308-1.285h1.781A2.966,2.966,0,0,1,1111.049,480.04Z",
    transform: "translate(-1107.69 -472.465)",
    fill: "#060b1e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(710.554 443.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(0 6.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1194.058,505.99a.406.406,0,0,0-.383.428.438.438,0,0,0,.383.428.443.443,0,0,0,.428-.428A.414.414,0,0,0,1194.058,505.99Z",
    transform: "translate(-1193.675 -505.99)",
    fill: "#060b1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(0.383 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1197.462,443.84h0v4.238h0a2.457,2.457,0,0,1,0,4.915h0v4.238h0a6.735,6.735,0,0,0,6.718-6.718A6.668,6.668,0,0,0,1197.462,443.84Z",
    transform: "translate(-1197.462 -443.84)",
    fill: "#060b1e"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMusic);
export default __webpack_public_path__ + "static/media/MyMusic.946f3e9d9a842726b268b1383345cf3c.svg";
export { ForwardRef as ReactComponent };